package pl.decks.personal.components.widgets.splitcard

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.style.toModifier

@Suppress("unused")
class SplitCardScope(private val columnScope: ColumnScope) {
    @Composable
    fun CardDivider() = HorizontalDivider(SplitCardStylesheet.Divider.toModifier())
}


@Composable
fun SplitCard(
    modifier: Modifier = Modifier,
    content: @Composable SplitCardScope.() -> Unit
) = Column(modifier = SplitCardStylesheet.Card.toModifier().then(modifier)) {
    val scope = SplitCardScope(this)
    scope.content()
}
